import React from 'react';
import Dropdown from 'react-dropdown';
import PropTypes from 'prop-types';
// import 'react-dropdown/officeCalendarWebStyle.css';

const DropdownElement = ({ componentConfig }) => <Dropdown {...componentConfig} />;
DropdownElement.propTypes = { componentConfig: PropTypes.object };

export default DropdownElement;
